import { appInfo } from "@/common/data/appinfo";
export default [
    {
        path: '/mes-applications',
        name: 'mes.applications',
        component: ()=> import('@/views/mes-applications/index.vue'),
        meta:{
            title: appInfo?.type === "codsmi" ? "New Application(s)" : "New Application(s)",
            authRequired: true,
            acc: ['y51910']
        
        }
    },
    {
        path: '/mes-application/:id?',
        name: 'mes.application',
        component: ()=> import('@/views/mes-applications/view.vue'),
        meta:{
            title: appInfo?.type === "codsmi" ? "New Application" : "New Application",
            authRequired: true,
            acc: ['y11399']
        
        }
    },
   


]